import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

import RelatedGamesItem from './Item';

const RelatedGames = ({ relatedGames = [] }) => {
  return (
    <div className="smartico-tournament-games">
      <Label
        className="smartico-tournament-games-title"
        message="smartico_tournaments_related_games"
      />
      <div className="smartico-tournament-games-list">
        {relatedGames.map(({ ext_game_id, game_public_meta }, index) => {
          if (!ext_game_id || !game_public_meta?.enabled) return null;
          return (
            <RelatedGamesItem
              id={ext_game_id}
              image={game_public_meta.image}
              key={ext_game_id}
              name={game_public_meta.name}
              providerName={game_public_meta.game_provider}
              tabIndex={index}
            />
          );
        })}
      </div>
    </div>
  );
};

RelatedGames.propTypes = {
  relatedGames: PropTypes.arrayOf(PropTypes.object),
};

export default RelatedGames;
